// node modules
import React from 'react';
// ui-library
import { InfiniteScroll, Modal, View } from '@upstox/upstox-ui';
// modules
import { useStore } from 'modules/Stores';
import AppService from 'modules/App/service';
// components
import ReleaseNoteCard from '../ReleaseNoteCard';
import ReleaseNotesHeader from '../ReleaseNotesHeader';
// styles
import * as css from './styles';

const ReleaseNotesModal = () => {
  const { toggleModal } = useStore('AppStore');
  const { releaseNotes } = AppService.config || {};

  return (
    <Modal
      variant="sidebar"
      zIndex={20}
      onClose={() => toggleModal('releaseNotes')}
    >
      <View flexDirection="column" gap="small" css={css.modalContent}>
        <ReleaseNotesHeader />
        <InfiniteScroll
          items={releaseNotes.items.map(releaseNote => ({
            element: <ReleaseNoteCard {...releaseNote} />,
            id: `${releaseNote.date}-${releaseNote.link}`,
          }))}
          gap="medium"
          overflow="hidden"
        />
      </View>
    </Modal>
  );
};

export default ReleaseNotesModal;
